<template>
    <div class="mt-4 px-4">
        <DataTable
            ref="evidenciasTable"
            :value="evidenciasList"
            :loading="loading"
            responsiveLayout="scroll"
        >
            <template #header>
                <div class="flex justify-content-end align-items-center">
                    <Button v-if="manageEvidence" @click="handleAddEvidencia" class="mt-buttons">
                        Agregar Evidencia
                    </Button>
                </div>
            </template>
            <template #empty> No hay evidencias asociadas a esta actuación. </template>
            <template #loading> Cargando datos. </template>
            <Column field="url" header="URL">
            <template #body="{ data }">
                {{ data.Url }}
            </template>
            </Column>
            <Column
                headerStyle="width: 5em; text-align: right;"
                bodyStyle="padding-right:8px; text-align: right; "
            >
                <template #body="{ data }">
                    <div class="flex justify-content-end">
                        <CustomButton
                            tooltipText="Editar Evidencia"
                            icon="pi pi-pencil"
                            button-color="#FAC84C"
                            @click="handleEditEvidencia(data.Url, data.ActuacionEvidenciaID)"
                        />
                        <CustomButton
                            tooltipText="Eliminar Evidencia"
                            button-color="#D32F2F"
                            icon="pi pi-trash"
                            @click="handleDeleteEvidencia(data.ActuacionEvidenciaID)"
                        />
                    </div>
                </template>
            </Column>
            <template #footer>
                <div
                class="flex flex-column"
                style="align-items: flex-end; margin-right: 2.5%; gap: 5px"
                >
                <div>Total de evidencias: {{ evidenciasList.length}}</div>
                </div>
            </template>
        </DataTable>
        <ModalSucces 
            ref="evidenciasModalRef"
            :title="titleModal"
            :icon="iconModal"
            :colorIcon="colorIconModal"
            :message="messageModal"
            :showIcon="true"
            :dismissableMask="true"
            severity="primary"
        >
            <template #footer>
                <div class="flex flex-column gap-4">
                    <div class="flex flex-column">
                        <InputText
                            v-if="modalInput"
                            type="text"
                            placeholder="Ingrese la url de la evidencia."
                            v-model="urlEvidence"
                        />
                        <label v-if="showError" class="text-red-500">{{ urlError }}</label>
                    </div>
                    <div class="w-full flex justify-content-end gap-2">
                        <Button 
                            :label="cancelButtonModal"
                            class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
                            @click="closeModalTemplate(evidenciasModalRef)" 
                        />
                        <Button 
                            :label="isSubmitting ? '' : confirmButtonModal"
                            class="border-round-lg w-5 flex justify-content-center align-items-center" 
                            @click="handleModalConfirm"
                            :disabled="isSubmitting || showError"
                        >
                            <i v-if="isSubmitting" class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>   
                        </Button>
                    </div>
                </div>    
            </template>
        </ModalSucces>
    </div>
</template>
<script>
    import DataTable from 'primevue/datatable';
    import ModalSucces from '@/components/ModalSucces'
    import CustomButton from "@/components/custom-button/CustomButton.vue";

    import { useRest } from "@/composables/useRest";
    import { useToast } from "@/composables/useToast";
    import { useOfflineCompat } from '@/composables/useOfflineCompat';
    import { useStoreCompat } from "@/composables/useStoreCompat";

    import { defineComponent, ref, computed, onMounted, watch } from 'vue';

    export default defineComponent({
        name: 'EvidenciasTab',
        components:{
            DataTable,
            ModalSucces,
            CustomButton
        },
        setup(){
            const store = useStoreCompat()
            const rest = useRest()
            const toast = useToast()
            const offline = useOfflineCompat()
            
            const sumario = computed(() => store.state.sumario);
            const user = computed(() => store.state.user);

            const evidenciasList = ref([])
            const loading = ref(true)
            const urlEvidence = ref('')
            const ActuacionEvidenciaID = ref('')

            const evidenciasModalRef = ref('')
            const modalInput = ref(null)
            const titleModal = ref('')
            const iconModal = ref('')
            const colorIconModal = ref('')
            const messageModal = ref('')
            const cancelButtonModal = ref('')
            const confirmButtonModal = ref('')
            const urlError = ref('')
            const modalMode = ref('')
            const isSubmitting = ref(false)

            const isOnlineActuacion = () => {
                return offline.onlineMode && sumario.value.id?.search("offline-") != 0;
            }

            const manageEvidence = computed(() => {
                const tipoUsuario = user.value?.userdata.tipoUsuario
                const usuariosPermitidos = ['Dpto.Criminalistica', 'Lab. Informatico Forense', 'Super User']
                return (
                    (isOnlineActuacion() || !offline.onlineMode) &&
                    sumario.value?.sumarioEstado !== 'Finalizada' &&
                    usuariosPermitidos.includes(tipoUsuario)
                );
            });

            const openModalTemplate = (type) => {
                type.value?.open();
            }
            
            const closeModalTemplate = (type) => {
                if(type.value){
                    type.value?.close();
                }else{
                    type.close()
                }
            }

            const isValidURL = (url) => {
                try {
                    new URL(url);
                    return true;
                } catch (_) {
                    return false;
                }
            }

            const setModalAttributes = ({icon, title, message, colorIcon, hasInput, cancelLabel = 'Cancelar', confirmLabel = 'Confirmar', mode = 'add' }) => {    
                titleModal.value = title
                iconModal.value = icon
                messageModal.value = message
                colorIconModal.value = colorIcon
                modalInput.value = hasInput
                cancelButtonModal.value = cancelLabel
                confirmButtonModal.value = confirmLabel
                modalMode.value = mode
            }

            const handleAddEvidencia = () => {
                urlEvidence.value = ''
                setModalAttributes({
                    icon: 'pi-exclamation-triangle',
                    title: 'Ingresar evidencia',
                    message: 'Por favor, ingrese la URL de la evidencia correspondiente en el campo a continuación.',
                    colorIcon: '#FBC02D',
                    hasInput: true,
                    confirmLabel: 'Guardar' 
                })
                urlError.value = ''
                openModalTemplate(evidenciasModalRef)
            }

            watch(urlEvidence, (val) => {
                if (val.trim() === '' || !isValidURL(val)) {
                    urlError.value = "La URL ingresada no es válida."
                }else{
                    urlError.value = ""
                }
            });

            const handleEditEvidencia = (url, urlID) => {
                setModalAttributes({
                    icon: 'pi-exclamation-triangle',
                    title: 'Editar evidencia',
                    message: 'Modifique la URL de la evidencia en el campo a continuación y confirme los cambios.',
                    colorIcon: '#FBC02D',
                    hasInput: true,
                    mode: 'edit'
                })
                ActuacionEvidenciaID.value = urlID
                urlEvidence.value = url
                openModalTemplate(evidenciasModalRef)
            }

            const handleDeleteEvidencia = (urlID) => {
                setModalAttributes({
                    icon: 'pi-question-circle',
                    title: 'Confirmar eliminación',
                    message: '¿Está seguro de que desea eliminar la evidencia? Esta acción no podrá revertirse.',
                    colorIcon: '#D32F2F',
                    hasInput: false,
                    mode: 'delete'
                })
                ActuacionEvidenciaID.value = urlID
                openModalTemplate(evidenciasModalRef)
            }

            const handleFetchEvidencias = async () => {
                try {
                    const response = await rest.get({
                        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-evidencia?search={"ActuacionID": [{"operator": "=", "value": "${sumario.value?.id}"}]}`
                    })
                    evidenciasList.value = response.data.data
                } catch (error) {
                    console.error(error);
                    toast.error('Error al pedir evidencias')
                }finally{
                    loading.value = false
                }
            }

            const deleteEvidence = async () => {
                if (isSubmitting.value) return;
                isSubmitting.value = true;
                try {
                    await rest.del({
                        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-evidencia/${ActuacionEvidenciaID.value}`
                    })
                } catch (error) {
                    console.error(error);
                    toast.error('Error al borrar evidencia') 
                }finally{
                    loading.value = true
                    isSubmitting.value = false
                    closeModalTemplate(evidenciasModalRef)
                    handleFetchEvidencias()
                }
            }

            const confirmEditEvidence = () => {
                setModalAttributes({
                    icon: 'pi-question-circle',
                    title: '¿Está seguro de que desea editar la URL de la evidencia?',
                    message: 'Si es así, haga clic en Confirmar. De lo contrario, haga clic en Cancelar.',
                    colorIcon: '#D32F2F',
                    hasInput: false,
                    mode: 'confirmEdit'
                })
                openModalTemplate(evidenciasModalRef)
            }

            const editEvidence = async () => {
                if (isSubmitting.value) return;
                isSubmitting.value = true;
                try {
                    await rest.put({
                        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-evidencia/${ActuacionEvidenciaID.value}`,
                        formData:{
                            Url: urlEvidence.value,
                            ActuacionID: sumario.value?.id
                        },
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                } catch (error) {
                    console.error(error);
                    toast.error('Error al borrar evidencia') 
                }finally{
                    loading.value = true
                    isSubmitting.value = false
                    closeModalTemplate(evidenciasModalRef)
                    handleFetchEvidencias()
                }
            }

            const addEvidence = async () => {
                if (isSubmitting.value) return;
                isSubmitting.value = true;
                try {
                    const formData = { 
                        ActuacionID: sumario.value?.id, 
                        Url: urlEvidence.value 
                    };
                    const optionsPost = {
                        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-evidencia`,
                        formData: formData,
                        headers: { "Content-Type": "multipart/form-data" },
                    };
                    await rest.post(optionsPost);
                    toast.success("Evidencia agregada correctamente.");
                } catch (error) {
                    console.error(error);
                    toast.error('Error al añadir evidencia')
                }finally{
                    urlEvidence.value = ''
                    loading.value = true
                    isSubmitting.value = false
                    closeModalTemplate(evidenciasModalRef)
                    handleFetchEvidencias()
                }
            }

            const showError = computed(() => {
                const isAddOrEdit = modalMode.value === 'add' || modalMode.value === 'edit'
                return isAddOrEdit && (urlError.value || !urlEvidence.value.trim());
            })


            const handleModalConfirm = () => {
                switch (modalMode.value) {
                    case 'add': return addEvidence();
                    case 'edit': return confirmEditEvidence();
                    case 'delete': return deleteEvidence();
                    case 'confirmEdit': return editEvidence();
                }
            };


            onMounted(async () => {
                await handleFetchEvidencias()
            })

            return{
                //ref
                evidenciasList,
                loading,
                evidenciasModalRef,
                titleModal,
                iconModal,
                colorIconModal,
                messageModal,
                urlEvidence,
                modalInput,
                cancelButtonModal,
                confirmButtonModal,
                urlError,
                modalMode,
                isSubmitting,

                //computed
                manageEvidence,
                showError,

                //methods
                handleAddEvidencia,
                handleEditEvidencia,
                handleDeleteEvidencia,
                openModalTemplate,
                closeModalTemplate,
                isValidURL,
                handleModalConfirm
            }
        }
    })
</script>
<style scoped>
.input-order {
  min-width: 250px;
  margin-top: -17px;
}

</style>